export const REPLACE_WORDS = {
    approved: 'Acknowledge',
    approval: 'Acknowledge',
    approver: 'Acknowledge',
    approve: 'Acknowledge',
    confirmation : 'Acknowledge',
    confirm : 'Acknowledge'
  };